import * as ActionTypes from "./actionTypes";

export const networkErrorAlert = error => ({
  type: ActionTypes.NETWORK_ERROR_ALERT,
  payload: {
    error: error,
  },
});

export const clearNetworkErrorAlert = error => ({
  type: ActionTypes.NETWORK_CLEAR_ALERT,
  payload: {
    error: error,
  },
});

export const sipError = message => ({
  type: ActionTypes.SIP_ERROR_ALERT,
  payload: {
    message: message,
  },
});

export const clearSipError = () => ({
  type: ActionTypes.SIP_CLEAR_ALERT,
  payload: {},
});






// WEBPACK FOOTER //
// ./src/actions/networkActions.js